
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("widget/launchpadV3-activity",{"1":function(container,depth0,helpers,partials,data) {
    return "<div class=\"fw-localveil\"></div>";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"launchpad-activity-title\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "</div> ";
},"5":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <table class=\"launchpad-activity-item\"><tr><td style=\"width:4px;border-radius:2px;background-color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\"></td><td style=\"padding-left:6px;\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "<br>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0))
    + "</td></tr></table> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"launchpad-activity\" style=\"background-image:url("
    + container.escapeExpression((lookupProperty(helpers,"imageUri")||(depth0 && lookupProperty(depth0,"imageUri"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"cover") : depth0),512,512,"r",{"name":"imageUri","hash":{},"data":data,"loc":{"start":{"line":1,"column":60},"end":{"line":1,"column":90}}}))
    + ");color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\" data-fw-onclick=\"launchpadclickaction|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"action") : depth0), depth0))
    + "|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"actionMetaId") : depth0), depth0))
    + "|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"url") : depth0), depth0))
    + "\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"darkenCover") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":193},"end":{"line":1,"column":251}}})) != null ? stack1 : "")
    + " <div class=\"launchpadV3-activity-content\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":295},"end":{"line":1,"column":372}}})) != null ? stack1 : "")
    + " <div class=\"launchpad-activity-text\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0))
    + "</div> "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"items") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":427},"end":{"line":1,"column":644}}})) != null ? stack1 : "")
    + " </div></div> ";
},"useData":true});
export default TPL;